import { ContractsValueObjectsAdditionalCompensationRecurrenceEnum } from 'generated/resources/graphql'
import i18n from 'modules/core/lib/i18n'

export const SUPPORTED_RECURRENCES = [
  'monthly',
  'every_3_months',
  'every_6_months',
  'every_12_months',
] as const satisfies readonly ContractsValueObjectsAdditionalCompensationRecurrenceEnum[]

export type DefaultRecurrence = (typeof SUPPORTED_RECURRENCES)[number]

export function isRecurrence(
  value: string
): value is ContractsValueObjectsAdditionalCompensationRecurrenceEnum {
  return SUPPORTED_RECURRENCES.some((r) => r === value)
}

export const recurrenceLabel = (
  recurrence: ContractsValueObjectsAdditionalCompensationRecurrenceEnum
): string => {
  switch (recurrence) {
    case 'monthly':
      return i18n.t('incentives.supported_recurrences.monthly')
    case 'every_2_months':
      return i18n.t(
        'contract_versions.additional_compensation.additional_compensation_form_fields.recurrence.every_2_months_option'
      )
    case 'every_3_months':
      return i18n.t('incentives.supported_recurrences.every_3_months')
    case 'every_4_months':
      return i18n.t(
        'contract_versions.additional_compensation.additional_compensation_form_fields.recurrence.every_4_months_option'
      )
    case 'every_5_months':
      return i18n.t(
        'contract_versions.additional_compensation.additional_compensation_form_fields.recurrence.every_5_months_option'
      )
    case 'every_6_months':
      return i18n.t('incentives.supported_recurrences.every_6_months')
    case 'every_7_months':
      return i18n.t(
        'contract_versions.additional_compensation.additional_compensation_form_fields.recurrence.every_7_months_option'
      )
    case 'every_8_months':
      return i18n.t(
        'contract_versions.additional_compensation.additional_compensation_form_fields.recurrence.every_8_months_option'
      )
    case 'every_9_months':
      return i18n.t(
        'contract_versions.additional_compensation.additional_compensation_form_fields.recurrence.every_9_months_option'
      )
    case 'every_10_months':
      return i18n.t(
        'contract_versions.additional_compensation.additional_compensation_form_fields.recurrence.every_10_months_option'
      )
    case 'every_11_months':
      return i18n.t(
        'contract_versions.additional_compensation.additional_compensation_form_fields.recurrence.every_11_months_option'
      )
    case 'every_12_months':
      return i18n.t('incentives.supported_recurrences.every_12_months')
    default: {
      const _exhaustiveCheck: never = recurrence
      return _exhaustiveCheck
    }
  }
}
